import { CsvBuilder } from "filefy";

export const exportCSVChampionshipDrivers = (championshipName: string) => (
    columns,
    data
) => {
    const fileName = `drivers ${championshipName.toLocaleLowerCase()}.csv`;

    const titleColumns = columns
        .filter((c) => c.export === undefined || c.export)
        .map((c) => c.title);

    const rows = data.map((driver) => {
        const row: string[] = [];

        row.push(driver.iracingId);
        row.push(driver.usedNumber);
        row.push(driver.displayName);
        row.push(driver.teamName || "Piloto Independente");

        return row;
    });

    new CsvBuilder(fileName)
        .setDelimeter(";")
        .setColumns(titleColumns)
        .addRows(rows)
        .exportFile();
};
